export { camelToSnake, simpleStringHash, snakeToCamel, snakeToCapitalized, splitByCommaOrSpace, truncateString } from '@eb/string-utils';